module.exports = __webpack_public_path__ + "img/zhxy_image_18.ecae29b3.png";